import {
  and,
  ControlProps,
  isOneOfEnumControl,
  optionIs,
  OwnPropsOfEnum,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsOneOfEnumProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";

const OneOfDropdownControl = ({
  data,
  options,
  uischema,
}: ControlProps & OwnPropsOfEnum) => {
  const uiSchemaOptions = uischema.options;
  const uiSchemaOptionsStyle = uiSchemaOptions?.oneOfStyle;
  const selectedOption = options?.find(option => option.value === data);
  const currentStyle =
    uiSchemaOptionsStyle &&
    selectedOption &&
    uiSchemaOptionsStyle[selectedOption.value];
  const label = uischema.label as string;

  return (
    <FormDetailWrapper data-testid="form-content-item">
      <FormDetailItem>{label} :</FormDetailItem>
      <FormDetailValue style={currentStyle}>
        {selectedOption?.label ?? ""}
      </FormDetailValue>
    </FormDetailWrapper>
  );
};

export const oneOfDropdownControlTester: RankedTester = rankWith(
  22,
  and(isOneOfEnumControl, optionIs("format", "dropdown")),
);

export default withJsonFormsOneOfEnumProps(OneOfDropdownControl);
